import React, {lazy} from 'react'
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import {
    withStyles,
    InputBase,
    Toolbar,
    Grid,
    Button,
    Select,
    MenuItem,
    AppBar as Appbar
} from '@material-ui/core';
import i18n from '../i18n';

import {setLanguage} from '../redux/auth/actions';
import {NavLink} from 'react-router-dom'
import KrLang from '../assets/icons/img-korea.png'
import EnLang from '../assets/icons/img-usa.png'
import Logo from "../assets/icons/logo.png";
import {withRouter} from "react-router-dom";


const CustomButton = lazy(() => import("./CustomButton"));
const HamburgerMenu = lazy(() => import("./HamburgerMenu"));

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderWidth: 0,
        borderRadius: 4,
        position: 'relative',
        backgroundColor: 'transparent',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            backgroundColor: 'transparent',
        },
    },
}))(InputBase);

const useStyles = theme => ({
    flexCenter: {
        display: "flex",
        alignItems: "center",
        justifyContent: 'space-between',
    },
    flexEnd: {
        display: "flex",
        alignItems: "center"
    },
    languageContainer: {
        display: 'flex',
        marginLeft: '20px',
        alignItems: 'center',
    },
    whiteButton: {
        fontSize: '14px',
        color: '#4f4f4f',
        marginRight: '10px',
        minHeight: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textTransform: 'none',
        [theme.breakpoints.down('md')]: {
            padding: 0
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
        "&.active": {
            color: 'black',
            fontFamily: 'Noto Sans KR Bold !important',
        },
        "&.hover": {
            color: '#4f4f4f'
        },
        "&.visited": {
            color: '#4f4f4f'
        },
        "&.link": {
            color: '#4f4f4f'
        },
    },
    overlay: {
        backgroundColor: '#fff',
        boxShadow: '0 1px 4px 0 rgba(27, 27, 27, 0.16)',
        [theme.breakpoints.up('lg')]: {
            fontSize: '20px'
        },
        [theme.breakpoints.down('lg')]: {
            fontSize: '18px'
        },
        [theme.breakpoints.down('md')]: {
            fontSize: '18px'
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px'
        },
    },
    toolbar: {
        minHeight: '70px',
        [theme.breakpoints.down('lg')]: {
            width: '90%',
            paddingLeft: '5%',
            paddingRight: '5%',
        },
        [theme.breakpoints.down('sm')]: {
            width: 'calc(100% - 48px)',
            paddingLeft: '24px',
            paddingRight: '24px',
        },
    },
    logoHeight: {
        height: '24px',
        width: '145px',
        marginLeft: '20px',
        marginRight: '20px',
        [theme.breakpoints.down('xs')]: {
            height: '20px',
            width: '120px',
        },
    },
    aTag: {
        textDecorationLine: 'none',
        color: '#4f4f4f'
    },
    appBar: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    joinButton: {
        padding: '6px 14px 4px 15px !important',
        textTransform: 'none',
        borderRadius: 8,
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    toggleMenu: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    }
})

class AppBar extends React.Component {
    handleChange = event => {
        this.props.setLanguage(event.target.value);
        i18n.changeLanguage(event.target.value);
    };

    render() {
        const { classes, lang, t } = this.props;

        return (
            <Appbar position="fixed" className={classes.overlay} elevation={0}>
                <Toolbar className={classes.toolbar}>
                    <Grid container justifyContent="space-between">
                        <Grid item className={classes.appBar}>
                            <Grid item className={classes.flexCenter}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <a href="/">
                                        <img alt={"logo"} src={Logo} className={classes.logoHeight}/>
                                    </a>
                                    <Button className={classes.whiteButton} size="large" to='/introduce'
                                            component={NavLink}>{t('AppBar.introduction')}</Button>
                                    <Button className={classes.whiteButton} size="large" to='/legal-effect'
                                            component={NavLink}>{t('AppBar.effort')}</Button>
                                    <Button className={classes.whiteButton}>
                                        <a
                                            href="https://eztrust.notion.site/EZ-Trust-2a324d2cda4e451bb3129cdb8239602b"
                                            className={classes.aTag}
                                            target={'_blank'}
                                        >
                                            {t('AppBar.careers')}
                                        </a>
                                    </Button>
                                    <Button className={classes.whiteButton}>
                                        <a
                                            href="https://blog.pinkii-swear.me"
                                            className={classes.aTag}
                                            target={'_blank'}
                                        >
                                            {t('AppBar.blog')}
                                        </a>
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item className={classes.flexEnd}>
                                <Button className={classes.whiteButton} size="large" to='/login'
                                        component={NavLink}>{t('AppBar.login')}</Button>
                                <CustomButton
                                    className={classes.joinButton}
                                    label={t("HomepageImage.button")}
                                    onClick={() => this.props.history.push('/sign-up')}
                                />
                                <div className={classes.languageContainer}>
                                    <Select
                                        labelId="demo-simple-select-outlined-label"
                                        id="demo-simple-select-outlined"
                                        value={lang}
                                        onChange={this.handleChange}
                                        label="Language"
                                        input={<BootstrapInput/>}
                                    >
                                        <MenuItem value="en" selected={lang === 'en'}>
                                            <img src={EnLang} alt="English" width={22} height={15}/>
                                        </MenuItem>
                                        <MenuItem value="ko" selected={lang === 'ko'}>
                                            <img src={KrLang} alt="Korean" width={22} height={15}/>
                                        </MenuItem>
                                    </Select>
                                    <div className={classes.toggleMenu}>
                                        <HamburgerMenu/>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Toolbar>
            </Appbar>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.auth.lang
});

const mapDispatchToProps = dispatch => ({
    setLanguage: (lang) => dispatch(setLanguage(lang))
});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(withRouter(AppBar))));
